import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import {  injectIntl, intlShape } from '../../util/reactIntl';

import {
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  Footer,
  Page,
  LayoutSingleColumn,
  ExternalLink,
} from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import css from './SellerTermsConditionsPage.module.scss';

export const SellerTermsConditionsPageComponent = props => {
  const { scrollingDisabled, intl} = props;

  const title = intl.formatMessage({ id: 'SellerTermsConditionsPage.title' });

  

  SellerTermsConditionsContent.propTypes = {
    title: PropTypes.string.isRequired,
    scrollingDisabled: PropTypes.bool.isRequired,
  };

  // Replace the $SELECTION_PLACEHOLDER$ with the new component
  return <SellerTermsConditionsContent title={title} scrollingDisabled={scrollingDisabled} />;
};

SellerTermsConditionsPageComponent.defaultProps = {
  scrollingDisabled: false,
};

const { bool } = PropTypes;

SellerTermsConditionsPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  // from injectIntl
  intl: intlShape.isRequired,
};

const SellerTermsConditionsPage = compose(withRouter, injectIntl)(SellerTermsConditionsPageComponent);

export default SellerTermsConditionsPage;

const QuestionsAndAnswers = () => (
    <div className={css.questionsContainer}>
      <div  className={css.section}>
        <strong>By opening a shop on Fave, you agree to the following:</strong>

        <h3>1. You’re selling original, fan-inspired creations</h3>
        <p>
          Your products must be your own work. That means no logos, artist names, lyrics, or other official marks you don’t have permission to use.
        </p>
        <p>
          Think <strong>fan-coded, not copied</strong>. Make it inspired, personal, and unmistakably yours.
        </p>
        <p>
          Need help knowing where the line is? Email us—we’d rather support you early than flag you later.
        </p>

        <h3>2. You need a PayPal account (personal or business)</h3>
        <p>
          That’s how we pay you. You’ll receive your earnings through PayPal once your orders are marked fulfilled. Either a personal or business account works—no stress if you're not set up as a business yet.
        </p>
        <p>
          And if you ever get stuck, we're here to walk you through it.
        </p>

        <h3>3. You’re the boss of your shop</h3>
        <p>
          You choose your prices. You decide where you ship. You set your own shop vibe.
        </p>
        <p>
          Just be clear about shipping costs, delivery timelines, and any customs info for international buyers. That way, fans know exactly what to expect—and everyone stays happy.
        </p>

        <h3>4. You handle fulfillment and returns—but we’ve got your back</h3>
        <p>
          You're in charge of packing and shipping your orders, and managing any refund or return requests. If something goes sideways, we’ll help troubleshoot and support both you and the buyer.
        </p>
        <p>
          This is your shop—but we’re in this together.
        </p>

        <h3>5. You follow our community standards</h3>
        <p>
          Keep it safe, respectful, and fandom-positive. That means:
        </p>
        <ul>
          <li>No hate speech, explicit content, or spam</li>
          <li>No trolling in product titles, descriptions, or messaging</li>
        </ul>
        <p>
          We want Fave to be a space where everyone feels welcome.
        </p>

        <h3>6. We may remove listings or shops that don’t follow the rules</h3>
        <p>
          If a product breaks the guidelines, gets flagged by a rights holder, or isn’t a fit for our community, we’ll reach out and work with you to fix it.
        </p>
        <p>
          We’ll always start with a conversation—but repeated or serious issues may result in removal.
        </p>
      </div>
    </div>
  );

export const ContentOnly = () => (
  <div className={css.contentContainer}>
    <h3>Merch Maker Terms & Conditions</h3>
    <QuestionsAndAnswers />
    <h5>
      Still have questions or looking for tips? Email us at{' '}
      <ExternalLink
        key="contactUsLink"
        href={'mailto:marketplace@faveforfans.com'}
      >
        marketplace@faveforfans.com
      </ExternalLink>
    </h5>
  </div>
);

export const SellerTermsConditionsContent = ({ title, scrollingDisabled }) => (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="FAQPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <ContentOnly />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );